/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export const stateOptions = {
    US: [
        {value: 'AL', label: 'Alabama'},
        {value: 'AK', label: 'Alaska'},
        {value: 'AZ', label: 'Arizona'},
        {value: 'AR', label: 'Arkansas'},
        {value: 'CA', label: 'California'},
        {value: 'CO', label: 'Colorado'},
        {value: 'CT', label: 'Connecticut'},
        {value: 'DE', label: 'Delaware'},
        {value: 'DC', label: 'District Of Columbia'},
        {value: 'FL', label: 'Florida'},
        {value: 'GA', label: 'Georgia'},
        {value: 'HI', label: 'Hawaii'},
        {value: 'ID', label: 'Idaho'},
        {value: 'IL', label: 'Illinois'},
        {value: 'IN', label: 'Indiana'},
        {value: 'IA', label: 'Iowa'},
        {value: 'KS', label: 'Kansas'},
        {value: 'KY', label: 'Kentucky'},
        {value: 'LA', label: 'Louisiana'},
        {value: 'ME', label: 'Maine'},
        {value: 'MD', label: 'Maryland'},
        {value: 'MA', label: 'Massachusetts'},
        {value: 'MI', label: 'Michigan'},
        {value: 'MN', label: 'Minnesota'},
        {value: 'MS', label: 'Mississippi'},
        {value: 'MO', label: 'Missouri'},
        {value: 'MT', label: 'Montana'},
        {value: 'NE', label: 'Nebraska'},
        {value: 'NV', label: 'Nevada'},
        {value: 'NH', label: 'New Hampshire'},
        {value: 'NJ', label: 'New Jersey'},
        {value: 'NM', label: 'New Mexico'},
        {value: 'NY', label: 'New York'},
        {value: 'NC', label: 'North Carolina'},
        {value: 'ND', label: 'North Dakota'},
        {value: 'OH', label: 'Ohio'},
        {value: 'OK', label: 'Oklahoma'},
        {value: 'OR', label: 'Oregon'},
        {value: 'PA', label: 'Pennsylvania'},
        {value: 'RI', label: 'Rhode Island'},
        {value: 'SC', label: 'South Carolina'},
        {value: 'SD', label: 'South Dakota'},
        {value: 'TN', label: 'Tennessee'},
        {value: 'TX', label: 'Texas'},
        {value: 'UT', label: 'Utah'},
        {value: 'VT', label: 'Vermont'},
        {value: 'VA', label: 'Virginia'},
        {value: 'WA', label: 'Washington'},
        {value: 'WV', label: 'West Virginia'},
        {value: 'WI', label: 'Wisconsin'},
        {value: 'WY', label: 'Wyoming'}
    ],
    CA: [
        {value: 'AB', label: 'Alberta'},
        {value: 'BC', label: 'British Columbia'},
        {value: 'MB', label: 'Manitoba'},
        {value: 'NB', label: 'New Brunswick'},
        {value: 'NL', label: 'Newfoundland and Labrador'},
        {value: 'NS', label: 'Nova Scotia'},
        {value: 'ON', label: 'Ontario'},
        {value: 'PE', label: 'Prince Edward Island'},
        {value: 'QC', label: 'Quebec'},
        {value: 'SK', label: 'Saskatchewan'},
        {value: 'NT', label: 'Northwest Territories'},
        {value: 'NU', label: 'Nunavut'},
        {value: 'YT', label: 'Yukon'}
    ],
    JP: [
        {value: '01', label: '北海道'},
        {value: '02', label: '青森県'},
        {value: '03', label: '岩手県'},
        {value: '04', label: '宮城県'},
        {value: '05', label: '秋田県'},
        {value: '06', label: '山形県'},
        {value: '07', label: '福島県'},
        {value: '08', label: '茨城県'},
        {value: '09', label: '栃木県'},
        {value: '10', label: '群馬県'},
        {value: '11', label: '埼玉県'},
        {value: '12', label: '千葉県'},
        {value: '13', label: '東京都'},
        {value: '14', label: '神奈川県'},
        {value: '15', label: '新潟県'},
        {value: '16', label: '富山県'},
        {value: '17', label: '石川県'},
        {value: '18', label: '福井県'},
        {value: '19', label: '山梨県'},
        {value: '20', label: '長野県'},
        {value: '21', label: '岐阜県'},
        {value: '22', label: '静岡県'},
        {value: '23', label: '愛知県'},
        {value: '24', label: '三重県'},
        {value: '25', label: '滋賀県'},
        {value: '26', label: '京都府'},
        {value: '27', label: '大阪府'},
        {value: '28', label: '兵庫県'},
        {value: '29', label: '奈良県'},
        {value: '30', label: '和歌山県'},
        {value: '31', label: '鳥取県'},
        {value: '32', label: '島根県'},
        {value: '33', label: '岡山県'},
        {value: '34', label: '広島県'},
        {value: '35', label: '山口県'},
        {value: '36', label: '徳島県'},
        {value: '37', label: '香川県'},
        {value: '38', label: '愛媛県'},
        {value: '39', label: '高知県'},
        {value: '40', label: '福岡県'},
        {value: '41', label: '佐賀県'},
        {value: '42', label: '長崎県'},
        {value: '43', label: '熊本県'},
        {value: '44', label: '大分県'},
        {value: '45', label: '宮崎県'},
        {value: '46', label: '鹿児島県'},
        {value: '47', label: '沖縄県'}
    ]
}
